import { motion } from "framer-motion";

const CHAPTERS = [
  { n: "01", title: "We start by understanding you.",
    body: "Every PLST journey begins with a conversation and an assessment — your health, injuries, exercise history, goals, and what you want to be able to do." },
  { n: "02", title: "No two people train the same way.",
    body: "Programs at PLST are built around your body and your goals. What you do, how much you do, and how you progress is chosen for you — never copied." },
  { n: "03", title: "Exercise is prescribed with intent.",
    body: "Every exercise has a reason — for your movement, your capacity, and where you want to be. Load, tempo and technique are chosen and adjusted with purpose." },
  { n: "04", title: "Progress is measured. Programs evolve.",
    body: "We review your training regularly and adjust as you get stronger, more capable and more confident. Nothing is left to guesswork." },
];

export default function WhyPLST() {
  return (
    <section id="why" className="relative py-24 lg:py-40" data-testid="why-section">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-4">
            <div className="md:sticky md:top-28">
              <motion.div
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
                className="text-xs uppercase tracking-[0.28em] text-[#8A8A8A]"
              >
                <span className="w-8 h-px bg-[#A67C00] inline-block align-middle mr-3" />
                Why PLST
              </motion.div>
              <motion.h2
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.1 }}
                className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-[#1E1E1E]"
              >
                Safety comes from <br />
                <span className="italic font-medium text-[#A67C00]">preparation,</span> <br />
                not protection.
              </motion.h2>
              <p className="mt-6 max-w-sm text-[#1E1E1E]/70 leading-relaxed">
                Four ideas that shape how we train, how we teach, and how we help people get genuinely stronger.
              </p>
            </div>
          </div>

          <div className="md:col-span-8 space-y-16 lg:space-y-24">
            {CHAPTERS.map((c, i) => (
              <motion.article
                key={c.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ duration: 0.85, ease: [0.2, 0.7, 0.2, 1], delay: i * 0.05 }}
                className="grid grid-cols-12 gap-6 items-start border-t border-[#1E1E1E]/10 pt-10"
                data-testid={`chapter-${c.n}`}
              >
                <div className="col-span-3 lg:col-span-2">
                  <div className="italic font-medium text-5xl md:text-6xl lg:text-7xl text-[#A67C00] leading-none">{c.n}</div>
                </div>
                <div className="col-span-9 lg:col-span-10">
                  <h3 className="font-display text-2xl md:text-3xl lg:text-4xl tracking-tight text-[#1E1E1E] leading-tight">{c.title}</h3>
                  <p className="mt-4 text-[#1E1E1E]/75 text-base md:text-lg leading-relaxed max-w-2xl">{c.body}</p>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
